import {getIsFirebaseConsentGiven, useLocalStorage} from '@aboutyou/storage';
import {exists} from '@aboutyou/utils';

/**
 * This key is still named like this for compatibility reasons
 */
export const DID_ASK_FOR_PUSH_NOTIFICATION = 'ay_returning_user';
const MAX_AMOUNT_OF_SESSION_BEFORE_RESET = 4;

export const useDidAskPushNotification = ({
  minimumAmountBeforeTrigger = 0,
  userSessionCount,
}: {
  minimumAmountBeforeTrigger?: number;
  userSessionCount: number;
}) => {
  const [didAskForPushNotification, setDidAskForPushNotification] =
    useLocalStorage({
      key: DID_ASK_FOR_PUSH_NOTIFICATION,
      defaultValue: {
        didAsk: false,
        atCount: 0,
      },
    });

  const isFirstTriggerConditionValid =
    userSessionCount === minimumAmountBeforeTrigger &&
    !didAskForPushNotification?.didAsk;

  const isReturningUserTriggerConditionValid =
    userSessionCount !== 0 &&
    userSessionCount %
      (MAX_AMOUNT_OF_SESSION_BEFORE_RESET + minimumAmountBeforeTrigger) ===
      0 &&
    userSessionCount > didAskForPushNotification!.atCount;

  const isPushNotificationReturnCountMet = () => {
    // TODO: https://aboutyou.atlassian.net/browse/AYFEP-3677
    // we probably want to rethink this logic => now it wont work without consent given
    const consentGiven = getIsFirebaseConsentGiven();

    if (exists(userSessionCount)) {
      return (
        consentGiven &&
        (isFirstTriggerConditionValid || isReturningUserTriggerConditionValid)
      );
    }
    return false;
  };

  const updateCountAfterFlyoutOpened = () => {
    const consetGiven = getIsFirebaseConsentGiven();

    if (
      exists(userSessionCount) &&
      consetGiven &&
      (isFirstTriggerConditionValid || isReturningUserTriggerConditionValid)
    ) {
      setDidAskForPushNotification({
        ...didAskForPushNotification,

        didAsk: true,
        atCount: userSessionCount,
      });
    }
  };

  return {updateCountAfterFlyoutOpened, isPushNotificationReturnCountMet};
};
